import { SelfieChallengeV2Status } from 'Containers/SelfieChallengeV2/types';

export const API_UNITIALIZED_ERROR = 'APIUninitializedError';
export const FACEBOOK_SDK_UNITIALIZED_ERROR = 'FacebookSDKUninitializedError';
export const FACEBOOK_API_ERROR = 'FacebookAPIError';
export const FACEBOOK_TIMEOUT_ERROR = 'FacebookTimeoutError';
export const LOGGED_OUT_FACEBOOK_ERROR = 'LoggedOutFacebookError';
export const LOGGED_OUT_TINDER_ERROR = 'LoggedOutTinderError';
export const UNKNOWN_API_ERROR = 'UnknownAPIError';
export const UNAUTHORIZED_API_ERROR = 'UnauthorizedAPIError';
export const RATE_LIMITED_ERROR = 'RateLimitedError';
export const REQUEST_TIMEOUT_ERROR = 'RequestTimeoutError';
export const SCRIPT_LOAD_TIMEOUT_ERROR = 'ScriptLoadTimeoutError';
export const BAD_REQUEST_API_ERROR = 'BadRequestAPIError';
export const SERVER_SIDE_API_ERROR = 'ServerSideAPIError';
export const UNDERAGE_USER_ERROR = 'UnderageUserError';
export const DOM_EXCEPTION = 'DOMException';
export const BLACKLISTED_USER_ERROR = 'BLACKLISTED_USER_ERROR';
export const APPEALABLE_BANNED_USER_ERROR = 'APPEALABLE_BANNED_USER_ERROR';
export const BANNED_USER_ERROR = 'BANNED_USER_ERROR';
export const UNDER_REVIEW_USER_ERROR = 'UNDER_REVIEW_USER_ERROR';
export const RSO_BANNED_USER_ERROR = 'RSO_BANNED_USER_ERROR';
export const EMAIL_ERROR = 'EMAIL_ERROR';
export const NETWORK_ERROR = 'NETWORK_ERROR';
export const SELFIE_CHALLENGE_V2_USER_ERROR = 'SELFIE_CHALLENGE_V2_USER_ERROR';
export const LOG = 'Log';

const MESSAGE_APPEALABLE_BANNED_USER_ERROR = 'User is banned (appealable)';
const MESSAGE_API_UNITIALIZED_ERROR =
  'Tried using authorized API request, before API helper was initialized';
const MESSAGE_FACEBOOK_SDK_UNITIALIZED_ERROR = 'Tried using Facebook SDK before it was initialized';
const MESSAGE_FACEBOOK_API_ERROR = 'Unknown Facebook API error';
const MESSAEG_FACEBOOK_TIMEOUT_ERROR = 'Facebook API timeout';
const MESSAGE_LOGGED_OUT_FACEBOOK_ERROR = 'User is logged out of Facebook';
const MESSAGE_LOGGED_OUT_TINDER_ERROR = 'User is logged out of Tinder';
const MESSAGE_UNKNOWN_API_ERROR = 'API request failed unexpectedly';
const MESSAGE_UNAUTHORIZED_API_ERROR = 'Missing API token when calling authorized endpoint';
const MESSAGE_RATE_LIMITED_ERROR = 'Request rate limited';
const MESSAGE_REQUEST_TIMEOUT_ERROR = 'Request timeout exceeded';
const MESSAGE_SCRIPT_LOAD_TIMEOUT_ERROR = 'Async script loading timeout exceeded';
const MESSAGE_BAD_REQUEST_API_ERROR = 'API responded with bad request status';
const MESSAGE_SERVER_SIDE_API_ERROR = 'Server responded with a server side error status';
const MESSAGE_UNDERAGE_USER_ERROR = 'User is underage';
const MESSAGE_BLACKLISTED_USER_ERROR = 'User is blacklisted';
const MESSAGE_SELFIE_CHALLEGNE_V2_ERROR = 'User is selfie challenged';
const MESSAGE_BANNED_USER_ERROR = 'User is banned';
const MESSAGE_UNDER_REVIEW_USER_ERROR = 'User is under review';
const MESSAGE_BROWSER_NETWORK_ERROR = 'Browser unable to access target resource';

export class HTTPErrorBase extends Error {
  status: number;
  error: Error | undefined;
  constructor(message: string, status: number, error?: Error) {
    super(message);
    this.status = status;
    this.error = error;
  }
}

class BannedUserErrorBase extends HTTPErrorBase {
  isBan: boolean;
  constructor(message: string, status: number, error?: Error) {
    super(message, status, error);
    this.isBan = true;
  }
}

export class APIUninitializedError extends Error {
  constructor() {
    super(MESSAGE_API_UNITIALIZED_ERROR);
    this.name = API_UNITIALIZED_ERROR;
  }
}

export class FacebookSDKUninitializedError extends Error {
  constructor() {
    super(MESSAGE_FACEBOOK_SDK_UNITIALIZED_ERROR);
    this.name = FACEBOOK_SDK_UNITIALIZED_ERROR;
  }
}

export class FacebookAPIError extends Error {
  constructor(error?: Error) {
    super(error?.message?.[MESSAGE_FACEBOOK_API_ERROR]);
    this.name = FACEBOOK_API_ERROR;
  }
}

export class FacebookTimeoutError extends Error {
  constructor() {
    super(MESSAEG_FACEBOOK_TIMEOUT_ERROR);
    this.name = FACEBOOK_TIMEOUT_ERROR;
  }
}

export class LoggedOutFacebookError extends Error {
  constructor() {
    super(MESSAGE_LOGGED_OUT_FACEBOOK_ERROR);
    this.name = LOGGED_OUT_FACEBOOK_ERROR;
  }
}

export class LoggedOutTinderError extends Error {
  constructor() {
    super(MESSAGE_LOGGED_OUT_TINDER_ERROR);
    this.name = LOGGED_OUT_TINDER_ERROR;
  }
}

export class UnknownAPIError extends HTTPErrorBase {
  constructor(message: string, status: number) {
    super(message || MESSAGE_UNKNOWN_API_ERROR, status);
    this.name = UNKNOWN_API_ERROR;
  }
}

export class UnauthorizedAPIError extends Error {
  constructor() {
    super(MESSAGE_UNAUTHORIZED_API_ERROR);
    this.name = UNAUTHORIZED_API_ERROR;
  }
}

export class RateLimitedError extends HTTPErrorBase {
  constructor(status: number, error: Error) {
    super(MESSAGE_RATE_LIMITED_ERROR, status, error);
    this.name = RATE_LIMITED_ERROR;
  }
}

export class RequestTimeoutError extends Error {
  constructor() {
    super(MESSAGE_REQUEST_TIMEOUT_ERROR);
    this.name = REQUEST_TIMEOUT_ERROR;
  }
}

export class ScriptLoadTimeoutError extends Error {
  constructor() {
    super(MESSAGE_SCRIPT_LOAD_TIMEOUT_ERROR);
    this.name = SCRIPT_LOAD_TIMEOUT_ERROR;
  }
}

export class BrowserNetworkError extends Error {
  constructor() {
    super(MESSAGE_BROWSER_NETWORK_ERROR);
    this.name = NETWORK_ERROR;
  }
}

export class BadRequestAPIError extends HTTPErrorBase {
  constructor(status: number, error: Error) {
    super(MESSAGE_BAD_REQUEST_API_ERROR, status, error);
    this.name = BAD_REQUEST_API_ERROR;
  }
}

export class ServerSideAPIError extends HTTPErrorBase {
  constructor(status: number, error: Error) {
    super(MESSAGE_SERVER_SIDE_API_ERROR, status, error);
    this.name = SERVER_SIDE_API_ERROR;
  }
}

export class UnderageUserError extends BannedUserErrorBase {
  ttl: number;
  underageToken: string;
  isOnboarding: boolean;
  isAppealable: boolean;
  policy: string | null;
  constructor(
    status: number,
    error: Error,
    ttl: number,
    underageToken: string,
    isOnboarding: boolean,
    isAppealable: boolean,
    policy: string | null
  ) {
    super(MESSAGE_UNDERAGE_USER_ERROR, status, error);
    this.name = UNDERAGE_USER_ERROR;
    this.ttl = ttl;
    this.underageToken = underageToken;
    this.isOnboarding = isOnboarding;
    this.isAppealable = isAppealable;
    this.policy = policy;
  }
}

export class BlacklistedUserError extends BannedUserErrorBase {
  appealToken: string | null;
  policy: string | null;
  constructor(status: number, error: Error, appealToken: string | null, policy: string | null) {
    super(MESSAGE_BLACKLISTED_USER_ERROR, status, error);
    this.name = BLACKLISTED_USER_ERROR;
    this.appealToken = appealToken;
    this.policy = policy;
  }
}

// Decalre SelfieChallengeV2
export class SelfieChallengeV2Error extends BannedUserErrorBase {
  selfieChallengeToken: string | null;
  selfieStatus: SelfieChallengeV2Status | null;
  constructor(
    status: number,
    error: Error,
    selfieChallengeToken: string | null,
    selfieStatus: SelfieChallengeV2Status | null
  ) {
    super(MESSAGE_SELFIE_CHALLEGNE_V2_ERROR, status, error);
    this.name = SELFIE_CHALLENGE_V2_USER_ERROR;
    this.selfieChallengeToken = selfieChallengeToken;
    this.selfieStatus = selfieStatus;
  }
}

export class BannedUserError extends BannedUserErrorBase {
  appealToken: string | null;
  constructor(status: number, error: Error, appealToken: string | null) {
    super(MESSAGE_BANNED_USER_ERROR, status, error);
    this.name = BANNED_USER_ERROR;
    this.appealToken = appealToken;
  }
}

export class UnderReviewUserError extends BannedUserErrorBase {
  constructor(status: number, error: Error) {
    super(MESSAGE_UNDER_REVIEW_USER_ERROR, status, error);
    this.name = UNDER_REVIEW_USER_ERROR;
  }
}

export class AppealableBannedUserError extends BannedUserErrorBase {
  challengeToken: string;
  refreshToken: string;
  arkoseDataBlob: string;
  constructor(
    status: number,
    error: Error,
    challengeToken: string,
    refreshToken: string,
    arkoseDataBlob: string
  ) {
    super(MESSAGE_APPEALABLE_BANNED_USER_ERROR, status, error);
    this.name = APPEALABLE_BANNED_USER_ERROR;
    this.challengeToken = challengeToken;
    this.refreshToken = refreshToken;
    this.arkoseDataBlob = arkoseDataBlob;
  }
}

export class RSOBannedUserError extends BannedUserErrorBase {
  constructor(status: number, error: Error) {
    super(MESSAGE_BANNED_USER_ERROR, status, error);
    this.name = RSO_BANNED_USER_ERROR;
  }
}

type LogParams = {
  customSampleRate?: number;
  message: string;
  shouldSample?: boolean;
};

/**
 * For Bugsnag to capture the stacktrace correctly, the Log must be instantiated in the same call stack as the error.
 *
 * Note: setting a custom sample rate for an individual event is discouraged and should be used as a last resort.
 */
export class Log extends Error {
  customSampleRate: number;
  severity: string;
  shouldSample: boolean;
  constructor({ customSampleRate = -1, message, shouldSample = true }: LogParams) {
    super(message);
    this.customSampleRate = customSampleRate;
    this.name = LOG;
    this.severity = 'info';
    this.shouldSample = shouldSample;
  }
}

export type ErrorTypes =
  | typeof APIUninitializedError
  | typeof AppealableBannedUserError
  | typeof BadRequestAPIError
  | typeof BannedUserError
  | typeof BlacklistedUserError
  | typeof BrowserNetworkError
  | typeof FacebookAPIError
  | typeof FacebookSDKUninitializedError
  | typeof FacebookTimeoutError
  | typeof LoggedOutFacebookError
  | typeof LoggedOutTinderError
  | typeof RSOBannedUserError
  | typeof RateLimitedError
  | typeof RequestTimeoutError
  | typeof ScriptLoadTimeoutError
  | typeof SelfieChallengeV2Error
  | typeof ServerSideAPIError
  | typeof UnauthorizedAPIError
  | typeof UnderReviewUserError
  | typeof UnderageUserError
  | typeof UnknownAPIError;
